import * as React from 'react';

const description = 'Powered by VCC Live Chat';
const linkToProvider = 'https://vcc.live/chat';

interface Props {
    classNames?: string;
}

export default class ChatProviderInfo extends React.Component<Props> {
    render() {
        return (
            <div className={`providerInfo ${this.props.classNames || ''}`}>
                <a onClick={this.openUrl}>
                    <span>{description}</span>
                </a>
            </div>
        );
    }

    openUrl = () => {
        window.open(linkToProvider, '_blank');
    };
}
